<div id="header-navigation-bar" class="l-container js-menu-contents" style="top: 0; width: 100%">
  <header class="l-header">
    <div class="l-header__main">
      <div class="l-wrap">
        <div class="l-wrap__inner">
          <div class="l-header__wrap">
            <div class="l-header__logo-area">
              <div [innerHTML]="headerService.getAnaLogo() | staticMsg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
